import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("선물하기")
const _hoisted_3 = { class: "gift_box_area is_done" }
const _hoisted_4 = { class: "amount_area" }
const _hoisted_5 = { class: "sender" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("지난 선물이 없습니다.")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")
  const _component_navigator = _resolveComponent("navigator")
  const _component_sub_navigator = _resolveComponent("sub-navigator")
  const _component_ticket_list_item = _resolveComponent("ticket-list-item")
  const _component_no_ticket_component = _resolveComponent("no-ticket-component")
  const _component_toTop = _resolveComponent("toTop")

  return (_openBlock(), _createBlock("div", {
    id: "wrap",
    class: ["wrap", {app_view: _ctx.isApp}]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_header_component, null, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode("div", {
      id: "content",
      class: ["content bg_gray", {'is_complete': _ctx.isEmpty}]
    }, [
      _createVNode("div", {
        class: ["tab_menu", {'fixed': _ctx.isEmpty}]
      }, [
        _createVNode(_component_navigator, { "navigator-code": "my" }),
        _createVNode(_component_sub_navigator, { "navigator-code": "unusableTicket" })
      ], 2),
      _withDirectives(_createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("ul", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tickets, (ticket) => {
              return (_openBlock(), _createBlock(_component_ticket_list_item, {
                key: ticket.ticketId,
                item: ticket,
                statusClass: _ctx.statusClass(ticket.ticketStatus),
                onMoveToDetailPage: ($event: any) => (_ctx.moveToDetailPage(ticket.ticketId))
              }, {
                refundableBadge: _withCtx(() => [
                  _withDirectives(_createVNode("span", {
                    class: ["state_badge", {wait: ticket.ticketStatus === 'REFUNDING', fail: ticket.ticketStatus === 'REFUNDFAIL' }]
                  }, null, 2), [
                    [_vShow, ticket.isRefundableBadgeStatus]
                  ])
                ]),
                senderOrRecipent: _withCtx(() => [
                  _createVNode("p", _hoisted_5, "from. " + _toDisplayString(ticket.senderName), 1)
                ]),
                _: 2
              }, 1032, ["item", "statusClass", "onMoveToDetailPage"]))
            }), 128))
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.isFirstLoading && !_ctx.isEmpty]
      ]),
      _createVNode(_component_no_ticket_component, {
        isEmpty: !_ctx.isFirstLoading && _ctx.isEmpty,
        showGiftImage: true
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["isEmpty"])
    ], 2),
    _createVNode(_component_toTop)
  ], 2))
}